import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import  styles from "./dell.module.css";
import Head from "next/head";
import Image from 'next/image';
import Campform from "./camp-form";
import qrscan from "../../assets/images/upsc/DuePayment/summercamp.jpg";
// import Upsdelhibanner from "../../assets/images/upsc/Kids-Summer-camp-Web-Banner.jpg";
// import MobUpscdelhibanner from "../../assets/images/upsc/Kids-Summer-camp-Mobile-Banner.jpg";
import Calendar from "../../assets/images/icon/Calender-01.png"; 
import Clock from "../../assets/images/icon/clock-01.png";
import IAS from "../../assets/images/icon/IAS.png";
import IPS from "../../assets/images/icon/IPS.png";
import IRS from "../../assets/images/icon/IFS.png";


export default function index() {
  const prelimlist =[
    {list:" The Union Public Service Commission (UPSC) is India's central recruitment board for top government jobs. It Selects Officers for the country's most powerful and respected Services."},    
  ]
  return (
    <>
    <Head>
   
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Civil Service Foundation Course for School Students</title>
                <meta name="title" content="Civil Service Foundation Course for School Students" />
                <meta name="description" content="Shankar IAS Academy offers the Best Summer Foundation Course for UPSC is perfect for school students to build a strong base early. Join now!" />
                <link rel="canonical" href="https://www.shankariasacademy.com/summer-foundation-course-for-upsc/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Civil Service Foundation Course for School Students" />
                <meta property="og:description" content="Shankar IAS Academy offers the Best Summer Foundation Course for UPSC is perfect for school students to build a strong base early. Join now!" />
                <meta property="og:url" content="https://www.shankariasacademy.com/summer-foundation-course-for-upsc/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
    </Head>
    <Navbar />
    <div className="container pt-3 ">
       <div className="rows pt-3 pb-3">
          <h1 className={`${styles.sectiontitle}`}>Junior IAS Programme for School Students 2026</h1>
      </div>
    </div>
  <div className="container">
        {/* <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={Upsdelhibanner}
                alt="orientation banner"
                title="UPSC orientation Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={MobUpscdelhibanner}
                alt="orientation banner"
                title="UPSC orientation"
                className="img-fluid w-100"
              />
            </div>
          </div> */}
      </div>

    <div className="container pt-3 pb-2 ">
       <div className="rows pt-3 pb-3">
         {/*} <h2 className={`${styles.sectiontitlesub}`}><b>Adding value to your last 12 months preparation</b></h2> */}
      </div>

 <section className="pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
    <div className="container"> 
       <div className="row">
          <div className="col-12 col-xl-4 pt-2 ">
                <div className={`${styles.facultyborder1}  h-100`}>
                    <div className="row pt-3 pb-3">
                        <div className="col-6 col-xl-6 offset-xl-2">
                            <span >Start from:</span><br />
                            <span className={`${styles.dayValue}`}>29<sup>th</sup></span><br />
                            <span>April 2026</span>
                        </div>
                        <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                          <Image src={Calendar} alt="clendar" width={50} height={50} />
                        </div>
                    </div>
              </div>
          </div>

          <div className="col-12 col-xl-4 pt-2">
            <div className={`${styles.facultyborder1} h-100`}>
              <div className="row pt-3 pb-3">
              <div className="col-6 col-xl-6 offset-xl-2">
                  <span>Timings:</span><br />
                  <span className={`${styles.dayValue}`}>04:00 pm </span><br />
                  <span>05:30 pm</span>
              </div>
              <div className="col-6 col-xl-4 pt-3 pt-xl-0">
              <Image src={Clock} alt="clendar" width={50} height={50} />
              </div>
              </div>
            </div> 
          </div>

          <div className="col-12 col-xl-4 pt-2">
              <div className={`${styles.facultyborder1} h-100`}>
                <div className="row pt-3 pb-3">
                    <div className="col-6 col-xl-6  offset-xl-2">   
                        <span>Fees</span><br />
                        <span className={`${styles.dayValue}`}>₹ 9,999</span><br />
                        <span>(Incl of GST)</span><br />
                    </div>
                   {/*} <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                        <span><a target="_blank" href="https://admissionsv1.shankariasacademy.com/"><button class={`${styles.normalbutton}`} type="submit">Pay Here</button></a></span>
                      </div> */}
                </div>
              </div>
          </div>
      </div>

        <div className="container">
            <div className="row">
              <div className="col-12 col-xl-6 pt-3">
                  <h5 className={`${styles.Feature} pt-3 mb-0`} >What is UPSC ?</h5>
                    <ul className={`${styles.ulclass} ps-1 pt-2`}>
                        {prelimlist.map((item,index)=>(
                        <li
                              className={`${styles.ulliclass} ${styles.acheiverrank}`}
                              id={styles.acheiverrankspecial} key={index}
                              >
                            <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                {item.list}
                                </p>
                            </div>
                        </li>
                        ))}
                    </ul>
              </div>
          
              <div className="col-12 col-xl-6 text-center pt-5"><a style={{color:"#000",fontSize:"18px"}} href="https://www.shankariasacademy.com/pdf/Summer-camp-2025.pdf" target="_blank"><i class="bi bi-file-earmark-pdf-fill" style={{fontSize:"35px",color:"#DB1B0D"}}></i> <br />Click here Summer Camp Programme Brochure</a></div>
                            
                            
            </div>
        </div>

    </div> 
</section>

<section className="pt-md-3 pt-4 justify-content-center" >
    <div className="container"> 
       <div className="row">
          <div className="col-4  col-md-4 pt-2 text-center">
                 <Image src={IAS} alt="clendar" className={`${styles.responsiveImage}`} />
                 <h2 className={`${styles.posting} pt-3 mb-0`}>IAS</h2>
                 <p className={`${styles.acheiverrank1} text-center mb-0 `}>Indian Administrative Service </p>
                 <p className={`${styles.acheiverrank1} text-center mb-0 d-none d-md-block`}>(District Collectors,Secretaries,etc.)</p>
          </div>

          <div className="col-4 col-md-4 pt-2 text-center">
                 <Image src={IPS} alt="clendar" className={`${styles.responsiveImage}`} />
                 <h2 className={`${styles.posting} pt-3 mb-0`}>IPS</h2>
                 <p className={`${styles.acheiverrank1} text-center mb-0 `}>Indian Police Service </p>
                 <p className={`${styles.acheiverrank1} text-center mb-0 d-none d-md-block`}>(Commissioners,DGPs,etc)</p>
          </div>

          <div className="col-4 col-md-4 pt-2 text-center">
                 <Image src={IRS} alt="clendar" className={`${styles.responsiveImage}`} />
                 <h2 className={`${styles.posting} pt-3 mb-0`}>IFS</h2>
                 <p className={`${styles.acheiverrank1} text-center mb-0 `}>Indian Foreign Service </p>
                 <p className={`${styles.acheiverrank1} text-center mb-0 d-none d-md-block`}>(Ambassadors & Diplomats)</p>
          </div>
      </div>
    </div> 
</section>



</div>

<div className="container ">
    <div className="row py-5">
        <div className="col-lg-6 col-12 pt-md-5 pb-5">
            <div className="container-fluid gx-0">
                <div className="row">
                        <div className={`${styles.section1bgbox} col p-5`}>
                            <div className={`${styles.sectionsubtitle} `}>Make Payment to Summer camp Programme</div> 
                            <div className={`${styles .acheivername}`}>Scan the QR code below to make payment</div>
                            <Image
                                src={qrscan}
                                className="img-fluid pt-3"
                                alt="environmentQrscan"
                                title="Environment Book QR Scan"
                                style={{ width: '300px', height: '300px' }}
                            />



                          <p className={`${styles.acheivername} pt-4`}>Kindly Share Payment Details to the following number on WhatsApp </p>
                        
                          <p className={`${styles.acheiverrank}`}>Mobile No: 9003190030 </p>
              
                        </div>

                       
                </div>
            </div>
        </div>
        <div className="col-lg-5 col-12 pt-1">
            <div className="container-fluid">
                <div className="row">
                <div className="col pt-lg-0 pt-sm-3">
                    <Campform />
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

    <Footer />
    </>
  )
}
